// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"157":"9c363348","163":"79f56512","508":"fb3a724e"}[chunkId] + ".chunk.css";
};